import styled from 'styled-components';

export const Container = styled.div`
  label {
    display: 'flex';
    margin-left: '5px';
    cursor: 'pointer';
    font-size: '12px';
    align-items: 'center';
  }
  span.itemLb {
    margin-bottom: 5px !important;
  }
`;
